export default function Error404Page() {
  return (
    <div>
      Error 404
    </div>
  )
}